export const branch = [
  { title: "Perlis", value: 0 },
  { title: "Kedah", value: 1 },
  { title: "Pulau Pinang", value: 2 },
  { title: "Perak", value: 3 },
  { title: "Selangor", value: 4 },
  { title: "Kuala Lumpur", value: 5 },
  { title: "Negeri Sembilan", value: 6 },
  { title: "Melaka", value: 7 },
  { title: "Johor", value: 8 },
  { title: "Pahang", value: 9 },
  { title: "Terengganu", value: 10 },
  { title: "Kelantan", value: 11 },
  { title: "Sabah", value: 12 },
  { title: "Sarawak", value: 13 },
];

export const states = [
  "Perlis",
  "Kedah",
  "Pulau Pinang",
  "Perak",
  "Selangor",
  "Kuala Lumpur",
  "Negeri Sembilan",
  "Melaka",
  "Johor",
  "Pahang",
  "Terengganu",
  "Kelantan",
  "Sabah",
  "Sarawak",
  "Labuan",
  "Putrajaya",
];

export const interests = [
  "GEMA He​roes",
  "GEMA Gr​een Heroes",
  "GEMA Negative Heroes",
  "GEMA Horizon",
  "GEMA Muzik",
  "GEMA E-Sport",
  "GEMA Fit",
  "GEMA Future",
];

export const genders = ["LELAKI", "PEREMPUAN"];

export const races = [
  "MELAYU",
  "CINA",
  "INDIA",
  "IBAN",
  "BUGIS",
  "KADAZANDUSUN",
  "BAJAU",
  "MURUT",
  "LAIN-LAIN",
];

export const religions = [
  "ISLAM",
  "BUDDHA",
  "KRISTIAN",
  "HINDU",
  "SIKH",
  "LAIN-LAIN",
];

export const education = [
  "SPM",
  "STPM",
  "DIPLOMA",
  "SARJANA MUDA",
  "SARJANA",
  "DOKTOR FALSAFAH",
  "LAIN-LAIN",
];

export const role = [
  { title: "ADMIN", value: 0 },
  { title: "STAFF", value: 1 },
  { title: "EVENT MANAGER", value: 3 },
];

export const eventStatus = [
  { title: "Baru", value: 0 },
  { title: "Aktif", value: 1 },
  { title: "Tamat", value: 2 },
];

export const eventEligibility = [
  { title: "Umum", value: 0 },
  { title: "Semua Ahli", value: 1 },
  { title: "Ahli Aktif", value: 2 },
  { title: "Alumni", value: 3 },
];

export const wallpapers = [
  "bg-1",
  "bg-2",
  "bg-3",
  "bg-4",
  "bg-5",
  "bg-6",
  "bg-7",
  "bg-8",
  "bg-9",
  "bg-10",
  "bg-11",
  "bg-12",
];

export const eventFieldType = [
  { title: "Text", value: "Text" },
  { title: "Dropdown", value: "Dropdown" },
  { title: "Checkbox", value: "Checkbox" },
  { title: "Multiple Choice", value: "Radio" },
];
